import {Profile} from "../../../lib/phinxapp/profiles/types";
import {MainLayout} from "../../../application/layouts";
import {private2Menu} from "./private2Menu";

export const private2Profile: Profile = {
  name: 'private2',
  component: MainLayout,
  menu: private2Menu,
};
